import { ReactNode, useMemo } from 'react';
import { LineTargetValueData } from 'types/protein';
import { useGetLineAndMachinesStatusesByLineIdQuery, useGetLineTargetsQuery } from 'api';

interface Props {
  lineId: string;
  startDatetime: string;
  endDatetime: string;
}

export const useLineStatusWidget = ({lineId, startDatetime, endDatetime}: Props) => {
  const {
    data: lineAndMachinesTuple,
    isLoading,
    isFetching,
    error
  } = useGetLineAndMachinesStatusesByLineIdQuery({
    lineId,
    startDatetime,
    endDatetime,
  });

  return {
    isLoading,
    isFetching,
    error,
    lineAndMachinesTuple
  };
};

export const useLineTargets = (lineId: string): {
  isLoading?: boolean;
  isFetching?: boolean;
  hasError?: ReactNode;
  hasMessage?: ReactNode;
  data: LineTargetValueData[];
  [key: string]: unknown;
  refetch?: () => void;
} => {

  const { data, isLoading, isError, isFetching, refetch } = useGetLineTargetsQuery({lineId});

  const CachedData = useMemo(() => {
    return (
      (data && (data as unknown as LineTargetValueData[])) ||
      ([] as LineTargetValueData[])
    );
  }, [data]);

  return {
    isLoading,
    isFetching,
    hasError: isError,
    data: CachedData,
    refetch
  };
};
